import { t } from '@/i18n';
import { appStore } from '@/state/appStore';
import { repo } from '@/storage/db';

function download(filename: string, content: string, mime: string) {
  const url = URL.createObjectURL(new Blob([content], { type: mime }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function exportBackup() {
  const data = await repo.exportAll();
  const date = new Date().toISOString().slice(0, 10);
  download(`assetlist-backup-${date}.json`, JSON.stringify(data, null, 2), 'application/json');
  appStore.notify(t('notice.exported'));
}

export function pickBackupFile(): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'application/json,.json';
    input.onchange = () => resolve(input.files?.[0] ?? null);
    input.click();
  });
}

export async function importBackup(file: File) {
  const text = await file.text();
  const data = JSON.parse(text) as Parameters<typeof repo.importAll>[0] & { version?: number };
  if (!Array.isArray(data.portfolios) || !Array.isArray(data.assets)) throw new Error(t('notice.notBackup'));
  await repo.importAll(data);
  await appStore.replaceAll();
  appStore.notify(t('notice.imported', { portfolios: data.portfolios.length, assets: data.assets.length }));
}
